// Shared, translation-free visuals for services (icon + gradient presets).
// Used by BOTH the CRM back-office and the public website so the mapping from a
// stored icon name / gradient class stays in one place.

import {
  Code2,
  Globe,
  LayoutGrid,
  ShoppingCart,
  LineChart,
  Search,
  Palette,
  Printer,
  Users,
  Plug,
  Puzzle,
  Layout,
  Sparkles,
  Megaphone,
  type LucideIcon,
} from "lucide-react";

// Maps the stored lucide icon name to the actual component. Falls back to
// Sparkles for unknown names so a custom service never breaks the UI.
const ICON_MAP: Record<string, LucideIcon> = {
  Code2,
  Globe,
  LayoutGrid,
  ShoppingCart,
  LineChart,
  Search,
  Palette,
  Printer,
  Users,
  Plug,
  Puzzle,
  Layout,
  Sparkles,
  Megaphone,
};

export const SERVICE_ICON_NAMES = Object.keys(ICON_MAP);

export function serviceIcon(name: string): LucideIcon {
  return ICON_MAP[name] ?? Sparkles;
}

// Curated gradient presets reused from the current service visuals so new
// services stay on-brand without free-typing tailwind classes.
export const SERVICE_GRADIENTS: string[] = [
  "from-violet-500 to-fuchsia-500",
  "from-fuchsia-500 to-pink-500",
  "from-cyan-500 to-blue-500",
  "from-orange-500 to-pink-500",
  "from-emerald-500 to-teal-500",
  "from-purple-500 to-indigo-500",
  "from-blue-600 to-cyan-500",
  "from-sky-500 to-cyan-500",
  "from-rose-500 to-orange-500",
  "from-blue-500 to-indigo-500",
  "from-teal-500 to-emerald-500",
  "from-pink-500 to-rose-500",
  "from-amber-500 to-orange-600",
];
